import { de as deDE } from 'date-fns/locale';
import { enUS } from 'date-fns/locale';
import type { Locale } from 'date-fns';
import { currentLanguage } from './translator';

/**
 * Maps an app locale code (e.g. de_CH, de_DE, en_US) to its date-fns Locale.
 */
export function getDateFnsLocale(locale?: string): Locale {
  const lang = locale || currentLanguage;

  switch (lang) {
    case 'de_CH':
    case 'de_DE':
    case 'gsw_CH':
      return deDE;
    case 'en_US':
      return enUS;
    default:
      return enUS;
  }
}

export { currentLanguage };
